import { parse, print } from 'graphql';
/**
 * helpers
 */
var extractOperationName = function extractOperationName(document) {
  var operationName = undefined;
  var operationDefinitions = document.definitions.filter(function (definition) {
    return definition.kind === "OperationDefinition";
  });
  if (operationDefinitions.length === 1) {
    var _operationDefinitions, _operationDefinitions2;
    operationName = (_operationDefinitions = operationDefinitions[0]) === null || _operationDefinitions === void 0 ? void 0 : (_operationDefinitions2 = _operationDefinitions.name) === null || _operationDefinitions2 === void 0 ? void 0 : _operationDefinitions2.value;
  }
  return operationName;
};
export var resolveRequestDocument = function resolveRequestDocument(document) {
  if (typeof document === "string") {
    var _operationName = undefined;
    try {
      var parsedDocument = parse(document);
      _operationName = extractOperationName(parsedDocument);
    } catch (err) {
      // Failed parsing the document, the operationName will be undefined
    }
    return {
      query: document,
      operationName: _operationName
    };
  }
  var operationName = extractOperationName(document);
  return {
    query: print(document),
    operationName: operationName
  };
};